import React, { useEffect, useState } from "react";
import { Form, Input, Button, Icon, Divider, Spin } from "antd";
import { alertify, generate_query_set, handleApiExceptions } from "../../../../../app_methods";
import { Vendor } from "../../../../../models/vendorPayouts";

const EditVendorProfileDynamicFormFunc = (props) => {
  const { form, vendor } = props;
  const profile = vendor.profile || {};
  const { getFieldDecorator, validateFields } = form;
  const [isLoading, setIsLoading] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [formAttributes, setFormAttributes] = useState([]);
  const [vendorDetails, setVendorDetails] = useState({});

  const fetchForm = async () => {
    setIsLoading(true);
    const response = await vendor.fetchFormAttributes();
    if (!response.success) {
      setIsLoading(false);
      handleApiExceptions(response);
      return;
    }
    setFormAttributes(response.data.vendor_form_attribute);
    setIsLoading(false);
  };

  const createVendorProfile = async (values) => {
    if (vendor && vendor.id) {
      updateVendorProfile(values);
      return;
    }
    setIsSaving(true);
    const response = await Vendor.get(values);
    if (!response.success) {
      setIsSaving(false);
      handleApiExceptions(response);
      return;
    }
    alertify("Success", `Vendor Profile ${vendor.is_edit ? "updated" : "created"} successfully.`, "success");
    setIsSaving(false);
    props.onVendorSave();
  };

  const updateVendorProfile = async (values) => {
    setIsSaving(true);
    const response = await vendor.update_vendor_profile({ "vendor_profile_attribute": values });
    if (!response.success) {
      setIsSaving(false);
      handleApiExceptions(response);
      return;
    }
    alertify(
      "Success",
      `Vendor Profile updated successfully.`,
      "success"
    );
    setIsSaving(false);
    props.onVendorSave();
  };

  const onSubmit = (e) => {
    e.preventDefault();
    validateFields((err, values) => {
      if (err) return;
      createVendorProfile(values);
    });
  };

  useEffect(() => {
    if (props && props.vendor.id) {
      fetchForm();
    }
  }, []);

  return (
    <Spin spinning={isLoading}>
      <Form onSubmit={onSubmit}>
        {formAttributes.map((inputField, index) => {
          return (
            <div className="row">
              <div className="col">
                {getFieldDecorator("id", {
                  initialValue: vendor.profile.id,
                })(<Input autoComplete="off" hidden />)}
                <Form.Item label={inputField.label}>
                  {getFieldDecorator(inputField.key, {
                    initialValue: vendor.profile[inputField.key],
                    rules: inputField.validations
                  })(<Input autoComplete="off" type={inputField.input_type} prefix={<Icon type="user" />} />)}
                </Form.Item>
              </div>
            </div>
          );
        })}

        <div className="w-100 d-flex justify-content-end mt-4">
          <Button htmlType="submit" type="primary" loading={isSaving}>
            Submit
          </Button>
        </div>
      </Form>
    </Spin>
  );
};

const EditVendorProfileDynamicForm = Form.create()(EditVendorProfileDynamicFormFunc);
export { EditVendorProfileDynamicForm };
